/**
 * Class names are used here because Safari has issues with style.removeProperty overflow
 * and IE has issues with style.overflow = null. This has better cross-browser support
 * and will play better with any future body style tweakers.
 *
 * This is done through JS only (not using some externally-supplied style) so all the
 * logic for handling this can stay in one place.
 */

const NO_SCROLL_CLASS = "body-scroll--no-scroll";
let paddingRuleEl;

function insertStyle(rule) {
  const styleRule = `body.${NO_SCROLL_CLASS} { ${rule} }`;
  let style = document.createElement('style');
  style.innerText = styleRule;
  document.head.appendChild(style);
  return document.head.lastElementChild
}

/**
 * THIS RUNS DURING JS LOAD
 */
insertStyle("overflow: hidden !important;");

function tryRemovePaddingRule() {
  if (paddingRuleEl) {
    document.head.removeChild(paddingRuleEl)
    paddingRuleEl = null;
  }
}

export function disableBodyScroll() {
  // Prevent content width from changing due to scrollbar appearing/disappearing
  const delta = window.innerWidth - document.body.offsetWidth;
  // Overflow-setting has to come after delta calculation, otherwise it's 0
  // Prevent resetting padding if the function is called multiple times
  // delta 0 is expected if the content is not currently scrolling OR we don't have visible scrollbars (e.g. touch)
  if (delta > 0) {
    tryRemovePaddingRule();
    paddingRuleEl = insertStyle(`padding-right: ${delta}px;`);
  }
  document.body.classList.add(NO_SCROLL_CLASS);
}

export function enableBodyScroll() {
  document.body.classList.remove(NO_SCROLL_CLASS);
  tryRemovePaddingRule();
}
